import gql from 'graphql-tag';

const DeleteDriverAccountSelf = gql(/* GraphQL */ `
  mutation DriverAccountSelfDelete($input: DriverAccountSelfDeleteInput!) {
    driverAccountSelfDelete(input: $input) {
      userErrors {
        ... on UserError {
          message
        }
      }
    }
  }
`);

export default DeleteDriverAccountSelf;
